import { queryOptions } from "@tanstack/react-query";
import type { WebStudioScope } from "../../api/boot";
import { loadCommandCatalog } from "../../api/commandCatalog";
import type { WebStudioCloudApiClient } from "../../api/generatedClient";

/**
 * TanStack Query option factory for the shell command catalog read. The
 * key carries cache identity only — scope plus the explicit refresh
 * generation; command labels, shortcuts, enablement, and route
 * destinations stay inside the generated response the query returns.
 */
export interface CommandCatalogQueryInput {
  generation?: number | undefined;
}

export function commandCatalogQueryOptions(
  client: WebStudioCloudApiClient,
  scope: WebStudioScope,
  input: CommandCatalogQueryInput = {},
) {
  return queryOptions({
    queryKey: ["commands", "catalog", scope, input.generation ?? 0] as const,
    queryFn: ({ signal }) => loadCommandCatalog(client, scope, { signal }),
  });
}
